// src/pages/MisPensionesPage.js
//
// Pantalla del estudiante/acudiente para ver sus cuotas de pensión y
// pagarlas vía Wompi (PagoPensionWidget.js).

import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, Grid, Chip, CircularProgress, Alert } from '@mui/material';
import { meService, pensionService } from '../services/api';
import PagoPensionWidget from '../components/PagoPensionWidget';

export default function MisPensionesPage() {
  const [matriculas, setMatriculas] = useState(null);
  const [cuotasPorMatricula, setCuotasPorMatricula] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const misMatriculas = await meService.getMisMatriculasInstitucionales();
        setMatriculas(misMatriculas);

        const entradas = await Promise.all(misMatriculas.map(async (m) => {
          const cuotas = await pensionService.getCuotas(m.institutionId, m.id);
          return [m.id, cuotas];
        }));
        setCuotasPorMatricula(Object.fromEntries(entradas));
      } catch (e) {
        setError(e?.message || 'No se pudieron cargar tus pensiones.');
      }
    })();
  }, []);

  if (error) {
    return <Container maxWidth="md" sx={{ py: 6 }}><Alert severity="error">{error}</Alert></Container>;
  }

  if (matriculas === null) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>;
  }

  if (matriculas.length === 0) {
    return (
      <Container maxWidth="sm" sx={{ py: 10, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>No tienes matrícula institucional</Typography>
        <Typography color="text.secondary">
          Si esperabas ver pensiones aquí, contacta a tu institución para confirmar tu matrícula.
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 4, color: '#1a4d2e' }}>
        Mis pensiones
      </Typography>

      {matriculas.map((m) => {
        const cuotas = cuotasPorMatricula[m.id] || [];
        const pendientes = cuotas.filter((c) => c.status !== 'Pagada' && c.status !== 'Exonerada');
        return (
          <Box key={m.id} sx={{ mb: 5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <Typography variant="h6" fontWeight={700}>{m.institutionName}</Typography>
              <Chip label={m.status} size="small" color={m.status === 'Activa' ? 'success' : 'default'} />
            </Box>

            {pendientes.length === 0 ? (
              <Alert severity="success">No tienes cuotas pendientes en esta institución. 🎉</Alert>
            ) : (
              <Grid container spacing={2}>
                {pendientes.map((cuota) => (
                  <Grid item xs={12} sm={6} key={cuota.id}>
                    <PagoPensionWidget cuota={cuota} />
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        );
      })}
    </Container>
  );
}
